import { Vue } from "Common/vue";
import Vuex from "vuex";
import actions from "./_actions";
import state from "./_state";
import getters from "./_getters";
import mutations from "./_mutations";

Vue.use(Vuex);

const ModalSwitchStore = new Vuex.Store({
    state,
    getters,
    actions,
    mutations,
});

export default ModalSwitchStore;
